module.exports = __webpack_public_path__ + "img/dark-s_ny.c3fb4911.jpg";